<template>
  <li class="fb-delimiter"></li>
</template>

<script>
import FbElementMixin from "./FbElementMixin";

export default {
  name: "FbDelimiter",
  mixins: [FbElementMixin],
};
</script>

<style lang="scss" scoped>
.fb-delimiter {
  border-bottom: 1px solid rgba(0, 0, 0, 0.42);
  margin: 20px 0px 10px 0px;
}
</style>
